import { useCallback, useEffect, useState } from 'react';

import { useAppSelector } from '@core/js/store/hooks';
import { useAutoGameLaunch } from '@interlayer/js/app/components/main/Games/hooks/useGameLaunch';
import { useCheckOccupation } from '@interlayer/js/app/hooks/user/hooks/useCheckOccupation';

export type TUseSearchNotification = {
    ID: string;
    data?: {
        type?: string;
        result?: {
            gameCode: string;
        };
    };
}

export const useHandleSearchNotification = () => {
    const [gameCode, setGameCode] = useState('');
    const game = useAppSelector((state) => state.gamesConfiguration?.[gameCode]);
    const launchGame = useAutoGameLaunch(game);
    const checkOccupation = useCheckOccupation({ shouldCheckRequested: false, shouldCheckForce: true });

    useEffect(() => {
        if (gameCode) {
            launchGame();
            setGameCode('');
        }
    }, [gameCode, launchGame]);

    return useCallback((response: TUseSearchNotification) => {
        if (response.data?.type === 'game' && response.data?.result?.gameCode && !checkOccupation()) {
            setGameCode(response.data.result.gameCode);
        }
    }, [checkOccupation]);
};
